var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { BaseLink, BaseText } from "../../designSystem";
import theme from "../../designSystem/theme";
var LearnMoreLink = styled(BaseLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  margin: auto;\n\n  &:hover {\n    opacity: ", ";\n  }\n"], ["\n  width: fit-content;\n  margin: auto;\n\n  &:hover {\n    opacity: ", ";\n  }\n"])), theme.hover.opacity);
var LearnMoreText = styled(BaseText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: underline;\n"], ["\n  text-decoration: underline;\n"])));
var LearnMoreArrow = styled(BaseText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-decoration: none;\n  margin-left: 5px;\n"], ["\n  text-decoration: none;\n  margin-left: 5px;\n"])));
var LearnMoreWallet = function () { return (_jsxs(LearnMoreLink, __assign({ to: "https://ethereum.org/en/wallets/", target: "_blank", rel: "noopener noreferrer", className: "w-100" }, { children: [_jsx(LearnMoreText, { children: "Learn more about wallets" }, void 0), _jsx(LearnMoreArrow, { children: "\u2192" }, void 0)] }), void 0)); };
export default LearnMoreWallet;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=LearnMoreWallet.js.map